import { useState } from 'react';
import Modal from '@/common/Modal';
import { TourBagIronSet } from '@/api/models';
import clubStyles from '../Club.module.scss';
import styles from './NewSetModal.module.scss';

interface INewSetModalProps {
  showNewSetModal: boolean;
  closeNewSetModal: () => void;
  ironSets: TourBagIronSet[];
  // eslint-disable-next-line no-unused-vars
  onAddNewSet: (name: string) => void;
}

function NewSetModal({ showNewSetModal, closeNewSetModal, ironSets, onAddNewSet }: INewSetModalProps) {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const currentNames = ironSets.map((set) => set.tourBagIronSetName?.toLocaleLowerCase());

  const addNewSet = () => {
    if (!name) {
      setError('Please pick a set name.');
      return;
    }
    if (currentNames.includes(name?.toLocaleLowerCase())) {
      setError('This name already exists, please pick a different one.');
      return;
    }
    setError(''); // reset error
    onAddNewSet(name);
  };

  return (
    <Modal isOpen={showNewSetModal} onClose={closeNewSetModal} className={styles.modal}>
      <div className={styles.container}>
        <div className={styles.title}>Add New Set</div>
        <input placeholder="Set Name" value={name} onChange={(event) => setName(event.target.value)} className={styles.input} />
        {error && <span className={clubStyles.errors}>{error}</span>}
        <div className={styles.buttons}>
          <button onClick={closeNewSetModal}>Cancel</button>
          <button onClick={addNewSet}>Add Set</button>
        </div>
      </div>
    </Modal>
  );
}

export default NewSetModal;
